import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function mensagemSistemaEquipamentoPosto(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@mensagemSistemaEquipamentoPosto/FIND_DATA':
      case '@mensagemSistemaEquipamentoPosto/UPDATE_DATA':
      case '@mensagemSistemaEquipamentoPosto/DELETE_DATA':
      case '@mensagemSistemaEquipamentoPosto/STORE_DATA':
      case '@mensagemSistemaEquipamentoPosto/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@mensagemSistemaEquipamentoPosto/SUCCESS_REMOVE':
      case '@mensagemSistemaEquipamentoPosto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@mensagemSistemaEquipamentoPosto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@mensagemSistemaEquipamentoPosto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@mensagemSistemaEquipamentoPosto/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
